var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['image-icon', _vm.name],style:({'color': _vm.color, 'font-size': _vm.size + 'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }